// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./translation/en.json";
import arTranslations from "./translation/ar.json"; // Import Arabic translations

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations }, // English translations
      ar: { translation: arTranslations }, // Arabic translations
    },
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;